import React, { Component } from 'react'
import { Row, Col } from 'react-bootstrap';
import { toaster, Spinner } from 'evergreen-ui';
import Context from '../../assets/js/Context';
import axios from 'axios';
import Cookies from "universal-cookie";
import host from '../../assets/js/Host';
import 'react-phone-input-2/lib/style.css'
// import Lottie from 'lottie-react-web'
// import animation from '../../assets/json/clean.json'
const cookies = new Cookies();

class Login extends Component {
  constructor(props) {
    super(props);
    this.state = {
      phone: '',
      password: '',
      spinBtn: false,
    }
  }
  signIN(e) {

    e.preventDefault()
    axios.post(host + `users/auth/login`, {
      phone: this.state.phone,
      password: this.state.password,
    })
      .then(response => {
    
        cookies.set("tokenUser", response.data.data.token, { expires: new Date(Date.now() + 604800000) });
     
     //   window.location.href = "/Category2";
        this.setState({ spinBtn: false })
      })
      .catch(error => {
        if (error.response) {
          this.setState({ spinBtn: false })
          toaster.danger("الرجاء التحقق من رقم الهاتف وكلمة المرور");
        }
      });
  }
  render() {
    return (
      <Context.Consumer>{ctx => {
        // if (ctx.value.login==='false') {
        return (
          <div style={{ height: '100vh' }}>
            <div id='mahmed'>
              <Row style={{ marginRight: '0px', width: '80%' }} id='ahmed_row' >
                <Col md={6} id='ahm_col2' >
                  <img src={require('../../assets/img/logo.jpg')} id='logoLoginIMG' alt='logo'  />
                </Col>
                <Col xs={12} md={6} id='ahm_col1' >
                  <div id='card_a21'  >
                    <div id='field1_ah' style={{ fontSize: '24px', fontWeight: '400', color: '#000', paddingTop: '3%' }}>تسجيل الدخول</div>
                    
                      <div id='field1_ah'>
                        <input autoComplete='off' type='number' placeholder=' رقم الهاتف' id='InputTExtDash1' 
                          onChange={(e) => this.setState({ phone: e.target.value })} />
                      </div>
                      <div id='field1_ah'>
                        <input autoComplete='off' type='password' placeholder=' كلمه المرور ' id='InputTExtDash1' 
                          onChange={(e) => this.setState({ password: e.target.value })} />
                      </div>
                      <div id='log1_ah'>
                        {!this.state.spinBtn ? (
                          <div id='log_ah' onClick={(e) => {
                            this.setState({ spinBtn: true })
                            this.signIN(e)
                          }}>تسجيل الدخول</div>
                        ) : (
                            <div id='log_ah' ><Spinner size={24} /></div>
                          )}
                      </div>
                    </div>
                </Col>
              </Row>
            </div>
            </div>
            )
          }
        // else if (ctx.value.login==='true') {
              //   window.location.href='/home'
              // }
              // else {
              //   return (
              //     <div style={{ width: '100%', height: 'calc(100vh - 80px)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
              //       <Lottie
              //         options={{
              //           animationData: animation
              //         }}
              //       />
              //     </div>
              //   )
              // }
            }
      </Context.Consumer>
        );
      }
      }
        export default Login;